var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 20,
    cy: 19.5,
    rx: 20,
    ry: 19.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.65C22.4 12.65 22.7 12.65 23.675 12.725C26.15 12.8 27.275 14 27.35 16.4C27.425 17.375 27.425 17.6 27.425 20C27.425 22.4 27.425 22.7 27.35 23.6C27.275 26 26.075 27.2 23.675 27.275C22.7 27.35 22.475 27.35 20 27.35C17.6 27.35 17.3 27.35 16.4 27.275C13.925 27.2 12.8 26 12.725 23.6C12.65 22.625 12.65 22.4 12.65 20C12.65 17.6 12.65 17.3 12.725 16.4C12.8 14 14 12.8 16.4 12.725C17.3 12.65 17.6 12.65 20 12.65ZM20 11C17.525 11 17.225 11 16.325 11.075C13.025 11.225 11.225 13.025 11.075 16.325C11 17.225 11 17.525 11 20C11 22.475 11 22.775 11.075 23.675C11.225 26.975 13.025 28.775 16.325 28.925C17.225 29 17.525 29 20 29C22.475 29 22.775 29 23.675 28.925C26.975 28.775 28.775 26.975 28.925 23.675C29 22.775 29 22.475 29 20C29 17.525 29 17.225 28.925 16.325C28.775 13.025 26.975 11.225 23.675 11.075C22.775 11 22.475 11 20 11ZM20 15.35C17.45 15.35 15.35 17.45 15.35 20C15.35 22.55 17.45 24.65 20 24.65C22.55 24.65 24.65 22.55 24.65 20C24.65 17.45 22.55 15.35 20 15.35ZM20 23C18.35 23 17 21.65 17 20C17 18.35 18.35 17 20 17C21.65 17 23 18.35 23 20C23 21.65 21.65 23 20 23ZM24.8 14.15C24.2 14.15 23.75 14.6 23.75 15.2C23.75 15.8 24.2 16.25 24.8 16.25C25.4 16.25 25.85 15.8 25.85 15.2C25.85 14.6 25.4 14.15 24.8 14.15Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c58b9d2fa1819cd1424ac9de0248a32d.svg";
export { ForwardRef as ReactComponent };